// @ts-nocheck
import Vue from 'vue';
import UniversalGemsDisplay from './gems/UniversalGemsDisplay.vue';
import { ProjectGemsService } from '@/services/projectGemsService';
import { organizationStore } from '@/stores/organizationStore';
import organizationService from '@/services/organizationService';
export default Vue.extend({
    name: 'ProjectCard',
    components: {
        UniversalGemsDisplay
    },
    props: {
        project: {
            type: String,
            required: true
        },
        projectId: {
            type: String,
            required: false
        },
        categoryCount: {
            type: Number,
            default: 0
        },
        sessionCount: {
            type: Number,
            default: 0
        },
        showGemsButton: {
            type: Boolean,
            default: true
        },
        // ✅ NEW: Pass hasGems from parent to avoid API calls
        hasGems: {
            type: Boolean,
            default: false
        },
        // ✅ NEW: Initial expanded state from user preferences
        initialExpanded: {
            type: Boolean,
            default: false
        },
        // ✅ NEW: Current organization ID for the project
        currentOrgId: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            gemsVisible: false,
            hasProjectGems: false,
            isCheckingGems: false,
            expanded: this.initialExpanded,
            organizationStore,
            selectedOrgId: this.currentOrgId || organizationStore.currentOrgId
        };
    },
    async mounted() {
        // ✅ PERFORMANCE FIX: Use prop instead of API call
        this.hasProjectGems = this.hasGems;
    },
    watch: {
        initialExpanded(newVal) {
            this.expanded = newVal;
        }
    },
    methods: {
        handleExpandToggle() {
            this.expanded = !this.expanded;
            console.debug('[ProjectCard] Toggled project expansion:', {
                project: this.project,
                expanded: this.expanded
            });
            this.$emit('expand-toggled', {
                project: this.project,
                expanded: this.expanded
            });
        },
        handleExpandAllCategories() {
            console.debug('[ProjectCard] Expanding all categories in project:', this.project);
            this.$emit('expand-all-categories', {
                project: this.project
            });
        },
        handleCollapseAllCategories() {
            console.debug('[ProjectCard] Collapsing all categories in project:', this.project);
            this.$emit('collapse-all-categories', {
                project: this.project
            });
        },
        async checkProjectGems() {
            try {
                this.isCheckingGems = true;
                console.debug('[ProjectCard] Checking gems for project:', this.project);
                // Use projectId if available, fallback to project name
                const idToUse = this.projectId || this.project;
                this.hasProjectGems = await ProjectGemsService.hasProjectGems(idToUse);
                console.debug('[ProjectCard] Project gems check result:', {
                    project: this.project,
                    hasGems: this.hasProjectGems
                });
            }
            catch (error) {
                console.warn('[ProjectCard] Error checking project gems:', error);
                this.hasProjectGems = false;
            }
            finally {
                this.isCheckingGems = false;
            }
        },
        handleGemsToggle() {
            try {
                this.gemsVisible = !this.gemsVisible;
                console.debug('[ProjectCard] Toggled gems visibility:', {
                    project: this.project,
                    visible: this.gemsVisible
                });
                this.$emit('gems-toggled', {
                    project: this.project,
                    visible: this.gemsVisible
                });
            }
            catch (error) {
                console.error('[ProjectCard] Error toggling gems:', error);
            }
        },
        handleGemsLoaded(gems) {
            console.debug('[ProjectCard] Project gems loaded:', {
                project: this.project,
                gemTypes: Object.keys(gems)
            });
            this.$emit('project-gems-loaded', {
                project: this.project,
                gems
            });
        },
        handleGemsError(error) {
            console.error('[ProjectCard] Project gems error:', error);
            this.$emit('project-gems-error', {
                project: this.project,
                error
            });
        },
        handleCardError(error) {
            console.error('[ProjectCard] Project gems card error:', error);
            this.$emit('project-gems-card-error', {
                project: this.project,
                error
            });
        },
        async handleOrgChange() {
            const newOrgId = this.selectedOrgId;
            const projectIdToUse = this.projectId || this.project;
            if (!newOrgId) {
                console.error('[ProjectCard] ❌ No organization selected');
                return;
            }
            const targetOrg = organizationStore.organizations.find(o => o.id === newOrgId);
            console.log('[ProjectCard] 🚀 Moving project to organization:', {
                project: this.project,
                projectId: projectIdToUse,
                fromOrg: this.currentOrgId,
                toOrg: newOrgId,
                targetOrgName: targetOrg?.name
            });
            try {
                console.log(`[ProjectCard] 📡 Calling API: PATCH /organizations/${newOrgId}/projects/${projectIdToUse}`);
                // Call backend API to reassign project
                await organizationService.assignProjectToOrganization(newOrgId, projectIdToUse);
                console.log('[ProjectCard] ✅ Project moved successfully');
                // Show success toast
                this.$emit('show-toast', `✅ Moved "${this.project}" to ${targetOrg?.name || 'organization'}`);
                // Emit event to parent to reload sessions
                this.$emit('project-moved', {
                    project: this.project,
                    projectId: projectIdToUse,
                    newOrgId
                });
            }
            catch (error) {
                console.error('[ProjectCard] ❌ Failed to move project:', error);
                console.error('[ProjectCard] ❌ Error details:', {
                    message: error.message,
                    response: error.response?.data,
                    status: error.response?.status,
                    statusText: error.response?.statusText,
                    fullError: JSON.stringify(error, null, 2)
                });
                // Revert dropdown selection
                this.selectedOrgId = this.currentOrgId || organizationStore.currentOrgId;
                // Show detailed error toast - handle all error formats
                let errorMsg = 'Unknown error';
                // Backend error response format: { error: { message: "..." } }
                if (error.response?.data?.error?.message) {
                    errorMsg = String(error.response.data.error.message);
                }
                else if (error.response?.data?.error && typeof error.response.data.error === 'string') {
                    errorMsg = String(error.response.data.error);
                }
                else if (error.response?.data?.message) {
                    errorMsg = String(error.response.data.message);
                }
                else if (error.message) {
                    errorMsg = String(error.message);
                }
                else if (typeof error === 'string') {
                    errorMsg = error;
                }
                else {
                    // Last resort: stringify the error object
                    errorMsg = JSON.stringify(error);
                }
                console.error('[ProjectCard] ❌ Final error message for toast:', errorMsg);
                this.$emit('show-toast', `❌ Failed to move "${this.project}": ${errorMsg}`);
            }
        }
    }
});
